/**
 * Weblate keys, not text.
 *
 * These defaults used to hold the Turkish labels directly, which put them out
 * of Weblate's reach: a module-scope constant is evaluated on import, where
 * there is no translator. Holding the key instead lets each caller resolve it
 * with the `t` it already has.
 */
export const DROPDOWN_DEFAULT_VALUE_KEYS = {
  OCCUPATION: 'dropdown-occupation-placeholder',
  DISTRICT: 'header-quicksearch-district',
  SERVICE: 'header-quicksearch-service',
}
